import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import Swal from 'sweetalert2';
import {HandleAlertsProvider} from '../../../utils/providers/handle-alerts-provider';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditVsCardComponent} from '../../alerts/cards/edit-vs-card/edit-vs-card.component';
import {EditUrlCardComponent} from '../../alerts/cards/edit-url-card/edit-url-card.component';
import {EditVirtualCardComponent} from '../../alerts/cards/edit-virtual-card/edit-virtual-card.component';

@Component({
  selector: 'app-cards-grid',
  templateUrl: './cards-grid.component.html',
  styleUrls: ['./cards-grid.component.scss']
})
export class CardsGridComponent implements OnInit {
  @Input() isSpecial = false;
  @Input() activeArrData;
  @Input() inactiveArrData;
  @Input() isVirtualAgency: boolean;
  @Input() all;
  @Input() mantenienceSection;
  @Output() editedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusField: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private handleAlertsProvider: HandleAlertsProvider,
    private serviceModal: NgbModal,
  ) {
  }

  ngOnInit(): void {
  }

  delete(card) {
    Swal.fire({
      title: `¿Desea eliminar <br> <b>${card.title}</b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deletedData.emit(card.id);
      }
    });
  }

  editCard(card) {
    if ((card.url === '' || card.url) && !card.column) {

      const modal = this.serviceModal.open(EditUrlCardComponent, {
        centered: true,
        windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-85pr'
      });
      modal.componentInstance.cardInfo = card;
      modal.result.then((res) => {
        this.editedData.emit(res);
      }, (reason) => {

      });

      // const {id, title, subTitle, img, img64, codeImg, orderId, activeButton, url} = card;
      // const dialogRef = this.handleAlertsProvider.getEditUrlCardsDialog(id, title, subTitle, img, img64, codeImg, orderId, activeButton, url);
      // dialogRef.afterClosed().subscribe(res => {
      //   if (res) {
      //     this.editedData.emit(res);
      //   }
      // });
    } else if (card.column) {
      const dataToSend = {
        ...card,
        all: this.all
      };
      const modal = this.serviceModal.open(EditVirtualCardComponent, {
        centered: true,
        windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-85pr'
      });
      modal.componentInstance.cardInfo = dataToSend;
      modal.result.then((res) => {
        this.editedData.emit(res);
      }, (reason) => {

      });
    } else  {

      const modal = this.serviceModal.open(EditVsCardComponent, {
        centered: true,
        windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-85pr'
      });
      modal.componentInstance.cardInfo = card;
      modal.result.then((res) => {
        this.editedData.emit(res);
      }, (reason) => {

      });

      // const {id, title, subTitle, img, img64, codeImg, orderId, activeButton} = card;
      // const dialogRef = this.handleAlertsProvider.getEditVsCardsDialog(id, title, subTitle, img, img64, codeImg, orderId, activeButton);
      // dialogRef.afterClosed().subscribe(res => {
      //   if (res) {
      //     this.editedData.emit(res);
      //   }
      // });
    }

  }

  changeStatusFromEnable(card, currentStatus) {
    this.statusField.emit({
      title: card.title,
      id: card.id,
      currentStatus: currentStatus === 'Desactivado'
    });
  }

  changeStatusFromDisable(card: any, currentStatus): any {
    if (this.isSpecial) {
      if (this.activeArrData.length === 5) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No puedes superar el límite de items  habilitados en esta sección, deshablita o elimina uno antes...',
        });
      } else {
        this.statusField.emit({
          title: card.title,
          id: card.id,
          currentStatus: currentStatus === 'Desactivado'
        });
      }
    } else if (!this.isSpecial) {
      if (this.activeArrData.length === 3) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No puedes superar el límite de items  habilitados en esta sección, deshablita o elimina uno antes...',
        });
      } else {
        this.statusField.emit({
          title: card.title,
          id: card.id,
          currentStatus: currentStatus === 'Desactivado'
        });
      }

    }
  }

}
